// The keeper's own cat sheet — extracted poses, transparent background.
const CATS = [
  { id: 33, name: "sitting" },
  { id: 39, name: "standing alert" },
  { id: 44, name: "pouncing" },
  { id: 7, name: "rolling play" },
  { id: 46, name: "dancing" },
];

export const BlackCat = ({ seed = "", pose, size = 40, className = "", inline = false }) => {
  if (pose === "none") return null;
  const variant = pose !== undefined && pose !== "" && pose !== null
    ? Number(pose) % CATS.length
    : (seed.split("").reduce((a, c) => (a * 31 + c.charCodeAt(0)) >>> 0, 7)) % CATS.length;
  return (
    <img src={`/cats/cat-${CATS[variant].id}.png`} alt=""
      className={`${inline ? "block" : "absolute bottom-1 right-1"} pointer-events-none ${className}`}
      style={{ width: size, height: "auto" }}
      data-testid={`black-cat-${variant}`} aria-hidden="true" />
  );
};
